// config
import { PATH_AFTER_LOGIN } from '../../config';
// components
import Iconify from '../../components/Iconify';

// ----------------------------------------------------------------------

const ICON_SIZE = {
  width: 22,
  height: 22,
};

const menuSimpleConfig = [
  {
    title: 'header.home',
    icon: <Iconify icon={'eva:home-fill'} {...ICON_SIZE} />,
    path: '/',
  },
  {
    title: 'header.dashboard',
    icon: <Iconify icon={'ant-design:dashboard-outlined'} {...ICON_SIZE} />,
    path: PATH_AFTER_LOGIN,
  },
];

export default menuSimpleConfig;
